import { Col, Row, Spin } from "antd";
import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../Actions/apiClient";
import AssetPath from "../../AssetPath/AssetPath";
import PageTitle from "../../Components/PageTitle/PageTitle";

const GalleryThumbnail = ({ urls }) => {
  if (!urls || urls.length === 0) return null;

  if (urls.length === 1) {
    return (
      <img
        src={urls[0]}
        alt=""
        style={{
          width: "100%",
          height: "270px",
          objectFit: "cover",
          borderRadius: "8px",
        }}
      />
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "repeat(3, 90px)",
        gap: "2px",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {urls.slice(0, 12).map((url, i) => (
        <img
          key={i}
          src={url}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ))}
    </div>
  );
};

const Gallery = () => {
  const navigate = useNavigate();
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  const INNOVATE_PHARMA_GALLERY = useMemo(() => ({
    _id: "innovate-pharma-2024-static",
    title: "Innovate Pharma 2024",
    description: "Bridging Continents for a Healthier Tomorrow",
    slug: null,
    isHardcoded: true,
    thumbnailUrls: [AssetPath.breadcrumb.innovatePhrama2024Gallery]
  }), []);

  useEffect(() => {
    apiClient
      .get("galleries/list")
      .then(({ data }) => {
        if (data && data.result) {
          setGalleries([INNOVATE_PHARMA_GALLERY, ...data.result]);
        }
      })
      .catch((error) => {
        console.error("Error fetching galleries:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [INNOVATE_PHARMA_GALLERY]);

  return (
    <>
      <PageTitle
        mainTitle="Gallery"
        breadcrumbItems={[{ name: "Gallery", path: "/gallery" }]}
        image={AssetPath.breadcrumb.galleryImage}
      />

      <section className="spacing">
        <div className="container">
          {loading ? (
            <div className="text-center py-5">
              <Spin size="large" />
            </div>
          ) : galleries.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-secondary">No galleries found.</p>
            </div>
          ) : (
            <Row
              gutter={[
                { xs: 0, sm: 16, md: 24, lg: 32 },
                { xs: 0, sm: 16, md: 24, lg: 20 },
              ]}
              align="left"
              justify="middle"
            >
              {galleries.map((gallery) => (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  key={gallery._id}
                  onClick={() =>
                    gallery.isHardcoded
                      ? navigate("/innovate-pharma-2024-bridging-continents-for-a-healthier-tomorrow-gallery")
                      : navigate(`/gallery/${gallery.slug}`)
                  }
                  className="cursor-pointer"
                >
                  <div className="details card border p-2">
                    <GalleryThumbnail urls={gallery.thumbnailUrls} />
                    <h3 className="h4 text-primary mb-0 mt-2">
                      {gallery.title}
                    </h3>
                    {gallery.description && (
                      <p
                        className="text-secondary font-4 mb-0"
                        dangerouslySetInnerHTML={{
                          __html: gallery.description,
                        }}
                      />
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </section>
    </>
  );
};

export default Gallery;
